import React from "react"
// styles
import {Oval, AlertWrapper, MessageWrapper} from "./index.style"

// UI
import {Row, Col} from "@uprise/grid"

const AlertCustom = ({message}) => {
	return (
		<Row>
			<Col style={{background: "#FFD5D5"}}>
				<AlertWrapper className='d-flex justify-start align-items-center'>
					<Oval className='m-r-4'>!</Oval>
					<MessageWrapper>{message}</MessageWrapper>
				</AlertWrapper>
			</Col>
		</Row>
	)
}

export default AlertCustom
